<template>
  <div>
    <container>
      <mobile-navbar slot="mobile-navbar"/>
      <web-navbar slot="web-navbar"/>
      <breadcrumb slot="breadcrumb"/>
      <app-header slot="header"/>
      <app-footer slot="footer"/>
      <vue-prograss/>
    </container>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'

import {
	Container,
	Breadcrumb,
	WebNavbar,
	MobileNavbar,
	AppHeader,
	AppFooter
} from '@/components/app/user/partials'

export default {
	name: 'user-layout',
	components: {
		Container,
		Breadcrumb,
		WebNavbar,
		AppHeader,
		MobileNavbar,
		AppFooter
	},
	computed: {
		...mapGetters('User', ['user', 'onlineUsers'])
	},
	watch: {
		// user: {
		// 	handler (newVal, oldVal) {
		// 		if (newVal && newVal !== oldVal) {
		// 			this.subscribeForMembersPresence()
		// 		}
		// 	},
		// 	deep: true
		// }
	},
	mounted () {
		// this.setPermissions(this.$auth.user().permissions)
		// this.setModules(this.$auth.user().modules)
		// this.setUser(this.$auth.user().user)
	},
	methods: {
		...mapMutations('User', ['setUser', 'setPermissions', 'setModules', 'setOnlineUsers']),
		subscribeForMembersPresence () {
			const { id, name, saasAppId, surname } = this.user
			this.$socket.emit('subscribe', { channel: `sass:${this.user.saasAppId}`, user: { id, name, saasAppId, surname } })

			this.sockets.subscribe('presence:subscribed', (payload) => {
				this.setOnlineUsers(payload[1])
			})

			this.sockets.subscribe('presence:joining', (payload) => {
				this.setOnlineUsers([...this.onlineUsers, payload[1]])
			})

			this.sockets.subscribe('presence:leaving', (payload) => {
				this.setOnlineUsers(this.onlineUsers.filter(user => user.id !== payload[1].id))
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/layouts/user/index.vue